export default {
  error: false,
  messages: [],
  isOpen: false,
  isLoading: false,
  hasLoaded: false,
}
